export const environment = {
  production: true,
  // csibefrontend: 'https://focus.roarinc.com/csibefrontend/',
  // csibefrontend: 'https://focus-dev.roarinc.it/csibefrontend/',
  // csibefrontend: "https://roar-last.wittyriver-6d22c846.westeurope.azurecontainerapps.io/csibefrontend/",
  // csibefrontend: 'csibefrontend/',
  // @ts-ignore
  //csibefrontend: window["env"]["csibefrontend"] || 'https://test/sibefrontend/',
  // @ts-ignore
  //csibe: window["env"]["csibe"] || 'https://test/sibefrontend/',

  // csibefrontend: 'http://localhost:8080/csibefrontend/',
  // csibe: 'http://localhost:8081/csibe/',


  csibefrontend: 'https://dev.cxanalyticsportalcnh.com/csibefrontend/',
  csibe: 'https://dev.cxanalyticsportalcnh.com/csibe/',
  csireport: 'https://dev.cxanalyticsportalcnh.com/csibereport/',
  // csireport: 'http://localhost:8081/csi-download/',
  assets: "assets/",
  cookiesenabled: true,
  siteId:3
};
